import { selectPartner360Data } from 'legacy/lut/features/partner360/configuration'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { ModalDialog } from 'core-components/library/modalDialog'

import { ESP_TRANSLATION_KEYS } from '../../configs/translations'
import { EspActivitiesBoard } from '../espActivitiesBoard/EspActivitiesBoard'

import styles from './EspActivitiesModal.module.scss'

interface IEspActivitiesContentProps {
  partnerId: string
  onChangeSponsor?: () => void
  initialFormTarget?: string
}

const EspActivitiesContent = ({
  partnerId,
  onChangeSponsor,
  initialFormTarget,
}: IEspActivitiesContentProps) => (
  <EspActivitiesBoard
    partnerId={partnerId}
    onChangeSponsor={onChangeSponsor}
    initialFormTarget={initialFormTarget}
  />
)

interface IEspActivitiesModalProps {
  show: boolean
  partnerId: string
  onClose: () => void
  /** Hands the sponsor-change action back to the entry button, which owns both modals. */
  onChangeSponsor?: () => void
  /** `new` opens the log form at once; an activity id opens that engagement for editing. */
  initialFormTarget?: string
}

/** Account activities tracking: the log and the log-activity panel on one screen. */
export const EspActivitiesModal: FC<IEspActivitiesModalProps> = ({
  show,
  partnerId,
  onClose,
  onChangeSponsor,
  initialFormTarget,
}) => {
  const { partnerName } = useSelector(selectPartner360Data)

  const titleReplaceParams = useMemo(
    () => [{ key: '{partner_name}', value: partnerName }],
    [partnerName]
  )

  return (
    <ModalDialog<IEspActivitiesContentProps>
      show={show}
      onClose={onClose}
      size="xl"
      classes={{ window: styles.window, header: styles.header, body: styles.body }}
      header={() => (
        <div className={styles.title}>
          <Translation
            text={ESP_TRANSLATION_KEYS.activities.modalTitle}
            replaceParams={titleReplaceParams}
            span
          />
        </div>
      )}
      content={EspActivitiesContent}
      contentProps={{ partnerId, onChangeSponsor, initialFormTarget }}
    />
  )
}

EspActivitiesModal.displayName = 'EspActivitiesModal'
